<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <fieldset :disabled="formDisabled">
            <b-form-row>
                <b-col>
                    <div class="field-labels">
                        Describe how the college will—
                    </div>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(5)(A)]
                    </div>
                    <div class="info-text">
                        Provide CTE instructions and activities to prepare <u>all students</u> with the
                        skills necessary to pursue careers in high-skill, high-wage, or in-demand
                        industry sectors or occupations that will lead to self-sufficiency.
                    </div>
                    <div class="info-text-emphasis">
                        <b-link :to="{name: 'localApplication.HighSkillWageInDemandPrep'}">
                            See also Local Uses of Funds [Sec 135(b)(3)]
                        </b-link>
                    </div>
                    <b-form-textarea v-model="allStudents" :rows="3" />
                </b-col>
            </b-form-row>
            <br>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(5)(A)]
                    </div>
                    <div class="info-text">
                        Provide CTE instructions and activities to prepare <u>special populations</u> students
                        with the skills necessary to pursue careers in high-skill, high-wage, or in-demand
                        industry sectors or occupations that will lead to self-sufficiency.
                    </div>
                    <div class="info-text-emphasis">
                        <b-link :to="{name: 'localApplication.HighSkillWageInDemandPrep'}">
                            See also Local Uses of Funds [Sec 135(b)(3)]
                        </b-link>
                    </div>
                    <b-form-textarea v-model="specialPopulation" :rows="3" />
                </b-col>
            </b-form-row>
            <br>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(5)(B)]
                    </div>
                    <div class="info-text">
                        Prepare CTE participants for non-traditional fields.
                    </div>
                    <b-form-textarea v-model="nontraditionalFields" :rows="3" />
                </b-col>
            </b-form-row>
            <br>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(5)(C)]
                    </div>
                    <div class="info-text">
                        Provide equal access for special populations to career and
                        technical education courses, programs, and programs of study.
                    </div>
                    <b-form-textarea v-model="equalAccess" :rows="3" />
                </b-col>
            </b-form-row>
            <br>
            <b-form-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 134 (b)(5)(D)]
                    </div>
                    <div class="info-text">
                        Ensure that members of special populations will not be discriminated
                        against on the basis of their status as members of special populations.
                    </div>
                    <b-form-textarea v-model="discrimination" :rows="3" />
                </b-col>
            </b-form-row>
        </fieldset>
        <br>
        <b-form-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'specialPopulations';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'SpecialPopulations',

    props: {
        // formDisabled: { type: Boolean, default: true }
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Special Populations',
            nextModule: { name: 'localApplication.WorkBasedLearning' },
            previousModule: { name: 'localApplication.StrengthenAcademicAndTechnicalSkills' },
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`
        }),

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        allStudents: {
            get() { return this.localApplicationModuleContent.allStudents; },
            set(value) { this.updateContentField({ field: 'allStudents', value }); }
        },

        specialPopulation: {
            get() { return this.localApplicationModuleContent.specialPopulation; },
            set(value) { this.updateContentField({ field: 'specialPopulation', value }); }
        },

        nontraditionalFields: {
            get() { return this.localApplicationModuleContent.nontraditionalFields; },
            set(value) { this.updateContentField({ field: 'nontraditionalFields', value }); }
        },

        equalAccess: {
            get() { return this.localApplicationModuleContent.equalAccess; },
            set(value) { this.updateContentField({ field: 'equalAccess', value }); }
        },

        discrimination: {
            get() { return this.localApplicationModuleContent.discrimination; },
            set(value) { this.updateContentField({ field: 'discrimination', value }); }
        },
    },


    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>
